import * as Yup from 'yup';

export const ingCollaboratorSchema = Yup.object().shape({})
